<template>
  <div id="app">
    
    <router-view></router-view>
    <Toast />
    
  </div>
</template>
<style lang="less">
  
</style>
<script>
import Toast from '@/components/common/toast.vue';
export default {
  name: 'App',
  inject:['$toast'],
  data () {
    return {
      
    }
    
  },
  components:{
      Toast
  }
}
</script>
<style lang="less">
  #app{
    font-family: Helvetica, Arial, Helvetica, sans-serif;
  }
  
</style>